import { IOperation } from './i-operation';
import { ArticleRotationResult } from '@article/rotation/article-rotation-result';
import { ArticleRotationGroup } from '@article/rotation/article-rotation-group';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { RotateArticlePresenter } from '@project/components/article/presenter/rotate-article.presenter';
import { ArrayUtils } from '../../util/array-utils';

export class UndoRotateArticlesOperation implements IOperation {
  private _articleRotationResults: ArticleRotationResult[];
  private _rotationAngle: number;
  private _isSwitchRotation: boolean;
  private _isReversed: boolean;

  constructor(
    rotationResults: ArticleRotationResult[],
    private containerService: ContainerService,
    private rotateArticlePresenter: RotateArticlePresenter,
    angle: number,
    isSwitchRotation: boolean = false,
    isReversed: boolean = false
  ) {
    this._articleRotationResults = rotationResults;
    this._rotationAngle = angle;
    this._isSwitchRotation = isSwitchRotation;
    this._isReversed = isReversed;
  }

  public get rotatedArticleUsageIds(): string[] {
    const rotatedUsageIds: string[] = [];
    if (ArrayUtils.isNotEmpty(this._articleRotationResults)) {
      this._articleRotationResults.forEach((res) => ArrayUtils.mergeArrays(rotatedUsageIds, res.rotatedArticleUsageIds));
    }
    return rotatedUsageIds;
  }

  public getQualifiedClassName(): string {
    return 'UndoRotateArticlesOperation';
  }

  public getOperationDescription(): string {
    return '';
  }

  public async performRedo(): Promise<void> {
    this.rotateArticleContainer(this._rotationAngle, this._isReversed ? true : false);
  }

  public async performUndo(): Promise<void> {
    this.rotateArticleContainer(this._rotationAngle, this._isReversed ? false : true);
  }

  private rotateArticleContainer(angle: number, inverseRotation: boolean): void {
    for (const rotationResult of this._articleRotationResults) {
      const rotationGroup: ArticleRotationGroup = new ArticleRotationGroup(
        this.containerService.findArticleContainersInGlobalByGuids(rotationResult.rotatedArticleUsageIds),
        rotationResult.groupedRotation
      );
      this.rotateArticlePresenter.rotateArticleRotationGroup(rotationGroup, angle, inverseRotation, true, this._isSwitchRotation);
    }
  }
}
